import { useRef, useState } from "react";

import { ChevronDown } from "components/icons/generated";
import Button from "ds/components/Button";
import DropdownWrapper from "ds/components/Dropdown/DropdownWrapper";
import DropdownList from "ds/components/Dropdown/List";
import DropdownSection from "ds/components/Dropdown/Section";
import Toggle from "ds/components/Toggle";
import useEscapeKeypress from "hooks/useEscapeKeyPress";
import useOutsideClick from "hooks/useOutsideClick";

import styles from "./styles.module.css";

type ManageViewProps = {
  isSimpleView: boolean;
  onSimpleViewChange: (value: boolean) => void;
  isReversedView: boolean;
  onReversedViewChange: (value: boolean) => void;
};

const ManageView = ({
  isSimpleView,
  onSimpleViewChange,
  isReversedView,
  onReversedViewChange,
}: ManageViewProps) => {
  const wrapperRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const closeDropdown = () => setIsVisible(false);

  useOutsideClick(wrapperRef, closeDropdown);
  useEscapeKeypress(isVisible, closeDropdown);

  return (
    <DropdownWrapper ref={wrapperRef}>
      <Button
        variant="secondary"
        endIcon={ChevronDown}
        endIconRotate={isVisible ? "180" : undefined}
        withRotateTransition
        active={isVisible}
        onPress={() => setIsVisible((prev) => !prev)}
      >
        Manage view
      </Button>
      <DropdownList active={isVisible} position="bottomLeft" className={styles.dropdownList}>
        <DropdownSection topDivider={false} gap="medium" padding="large">
          <Toggle variant="switch" isSelected={isSimpleView} onChange={onSimpleViewChange}>
            Simplified view
          </Toggle>
          <Toggle variant="switch" isSelected={isReversedView} onChange={onReversedViewChange}>
            Reverse phase order
          </Toggle>
        </DropdownSection>
      </DropdownList>
    </DropdownWrapper>
  );
};

ManageView.displayName = "RunHistoryManageView";

export default ManageView;
